import View from 'root/view/base';

export default View.extend({
    initialize: function(options) {
        this.submit_button = options && options.submit_button ? options.submit_button : 'Save';
    },

    render: function() {
        var content =

        '<p>Having troubles in connecting with Jira? <a href="https://support.userback.io/en/articles/5209238" target="_blank">Find out more</a>.</p>' +
        '<form class="form-fluid">' +
            '<div class="row">' +
                '<div class="field-label">Jira Host</div>' +
                '<input type="url" class="solid medium" name="jira_host" maxlength="255" placeholder="https://example.atlassian.net" required>' +
            '</div>' +
            '<div class="row">' +
                '<div class="field-label">Jira Username or Email</div>' +
                '<input type="text" class="solid medium" name="username" maxlength="255" required>' +
            '</div>' +
            '<div class="row">' +
                '<div class="field-label">API Token</div>' +
                '<input type="password" class="solid medium" name="password" maxlength="255" required autocomplete="new-password">' +
                '<div class="margin-top-12"><a href="https://id.atlassian.com/manage/api-tokens#" class="primary popup" data-width="1024" data-height="600">Get my Jira API Token <i class="fa-solid fa-square-arrow-up-right"></i></a></div>' +
            '</div>' +
            '<div class="sidebar-bottom">' +
                '<button class="primary" type="submit">' + this.submit_button + '</button>' +
            '</div>' +
        '</form>';

        this.$el.html(content);

        return this;
    }
});